<template>
  <router-view />
</template>
<script>
  export default {
    name: 'ContentLayout',
    data() {
      return {
      }
    },
  };
  </script>
  <style>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s;
  }
  
  .fade-enter, .fade-leave-to
    /* .fade-leave-active in <2.1.8 */ {
    opacity: 0;
  }
  </style>  